import { render } from "./ShoppingStats.vue?vue&type=template&id=4daa99dc"
import script from "./ShoppingStats.vue?vue&type=script&lang=js"
export * from "./ShoppingStats.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__